export function NewFormState() {
  return {
    list: [],
    pinnedList: [],
    currentPostId: null,
    isEditMode: false,
    commentsCount: 0,
    nextPageUrl: null,
    childFormCommentId: null,
    isLoading: false,
    isLoadingNext: false,
    isReady: false,
    isScrollToComments: false,
    targetCommentsId: null,
    isFocusStart: false,
  };
}
